exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-5f97ae42]{width:100%;height:21.333px;height:1.333333rem;background:#000}.footer h1[data-v-5f97ae42]{line-height:21.333px;line-height:1.333333rem;color:#b4b4b4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/data/efun/gw-template-pre/client/smsgz/assets","/static":"/data/efun/gw-template-pre/client/smsgz/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f97ae42","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/smsgz/components/common/foot/index.vue
// module id = KcRz
// module chunks = 0 1 2